export default __webpack_public_path__ + "static/media/fireFN26.9a08aed9.svg";